import Home from "./auth/Home";
import { Routes, Route } from 'react-router-dom'
import RegisterUser from "./pages/users/RegisterUser";
import Login from "./auth/Login";
import DashboardRouter from "./pages/dashboard/DashboardRouter";
import { useEffect } from "react";
import AddUserMain from "./pages/users/AddUserMain";
import ClientMain from "./pages/clients/ClientMain";
import ClientCompanyMain from "./pages/client-company/ClientCompanyMain";
import ClientCompanyTypeMain from "./pages/client-company-type/ClientCompanyTypeMain";
import Components from "./shared/components/components";
import TaskMain from "./pages/Task/TaskMain";
import ManageTaskMain from "./pages/ManageTask/ManageTaskMain";
import RoleSecurityMain from "./pages/role-security/RoleSecurityMain";
import ReportsMain from "./pages/reports/ReportsMain";
import UserProfile from "./pages/users/UserProfile";
import ResetPassword from "./auth/ResetPassword";
import LeadMain from "./pages/lead/LeadMain";
import ClientCommunication from "./pages/client-communication/ClientCommunication";
import ClientEnvironmentMain from "./pages/client-environments/ClientEnvironmentMain";
import TitleMain from "./pages/titles/TitleMain";
import EnquiryMain from "./pages/enquiry/EnquiryMain";
import SalesRegisterMain from "./pages/sales-register/SalesRegisterMain";
import RTOMain from "./pages/rto/RTOMain";
import FinanceRegisterMain from "./pages/finance-register/FinanceRegisterMain";
import CustomerMain from "./pages/customer/CustomerMain";
import ColorMain from "./pages/color/ColorMain";
import MasterDataMain from "./pages/master-data/MasterDataMain";
import VehicleMain from "./pages/vehicle/VehicleMain";
import DealerMain from "./pages/dealer/DealerMain"; 
import PurchaseRegisterMain from "./pages/purchase-register/PurchaseRegisterMain";
import ExpenseRegisterMain from "./pages/expense-register/ExpenseRegisterMain";
import FinancePartnerMain from "./pages/finance-partner/FinancePartnerMain";
import HandoverItemsMain from "./pages/handover-items/HandoverItemsMain";
import HandoverRegisterMain from "./pages/handover-register/HandoverRegisterMain";
import LoanApplicatgionFromMain from "./pages/loan-application-form/LoanApplicatgionFromMain";
import CalendarMain from "./pages/Calendar/CalendarMain";
import TodoListMain from "./pages/todo-list/TodoListMain";
import PaymentFollowupMain from "./pages/payment-followup/PaymentFollowupMain";
import GallaryMain from "./pages/Gallary/GallaryMain";
import ProductMain from "./pages/ec-admin/product/ProductMain";
import ProductCategoryMain from "./pages/ec-admin/product-category/ProductCategoryMain";
import ProductSubCategoryMain from "./pages/ec-admin/product-sub-category/ProductSubCategoryMain";
import HomepageBannerMain from "./pages/ec-admin/homepage-banner/HomepageBannerMain";
import VendorMain from "./pages/ec-admin/vendor/VendorMain";
import ProductDetailTabTypeMain from "./pages/ec-admin/product-detail-tab-type/ProductDetailTabTypeMain";
import PromoBannerMain from "./pages/ec-admin/promo-banner/PromoBannerMain";
import OrderFoodPage from "./pages/order-food/OrderFoodPage";
import PendingEnquiryReport from "./pages/reports/app2/PendingEnquiryReport";
import FollowupDueReport from "./pages/reports/app2/FollowupDueReport";
import UpcomingDeliveryReport from "./pages/reports/app2/UpcomingDeliveryReport";
import RtoPendingReport from "./pages/reports/app2/RtoPendingReport";
import FinancePendingReport from "./pages/reports/app2/FinancePendingReport";
import DailySalesReport from "./pages/reports/app2/DailySalesReport";
import SalesPerformanceReport from "./pages/reports/app2/SalesPerformanceReport";
import AreaDemandReport from "./pages/reports/app2/AreaDemandReport";
import TopModelsReport from "./pages/reports/app2/TopModelsReport";
import DeliverySlaReport from "./pages/reports/app2/DeliverySlaReport";
import ActivityReport from "./pages/reports/app2/ActivityReport";
import OpdFormDemo from "./pages/opd-form/OpdFormDemo";



function App() {
  useEffect(() => {
        
  }, [])
  return (
    <>
      <Routes>
        <Route path="/" element={<Login />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/opd" element={<OpdFormDemo />}></Route>
        <Route path="/home" element={<Home />}>
          <Route path="dashboard" element={<DashboardRouter />}></Route>
          <Route path="create-task"  element={<TaskMain Module={"Create Task"}/>}></Route>
          <Route path="manage-task"  element={<ManageTaskMain Module={"Manage Task"} DefaultTaskId={0}/>}></Route>
          <Route path="addUser"  element={<AddUserMain Module={"User"}/>}></Route>
          <Route path="addClient"  element={<ClientMain Module={"Clients"}/>}></Route>
          <Route path="client-company"  element={<ClientCompanyMain Module={"Client Company"}/>}></Route>
          <Route path="client-company-type"  element={<ClientCompanyTypeMain Module={"Client Company Type"} />}></Route>
          <Route path="components"  element={<Components Module={"Components"} />}></Route>
          <Route path="role-security"  element={<RoleSecurityMain Module={"Role Security"} />}></Route>
          <Route path="report"  element={<ReportsMain Module={"Reports"} />}></Route>
          {/* App2 report viewer pages (separate menu routes) */}
          <Route path="reports/pending-enquiry" element={<PendingEnquiryReport />}></Route>
          <Route path="reports/followup-due" element={<FollowupDueReport />}></Route>
          <Route path="reports/upcoming-delivery" element={<UpcomingDeliveryReport />}></Route>
          <Route path="reports/rto-pending" element={<RtoPendingReport />}></Route>
          <Route path="reports/finance-pending" element={<FinancePendingReport />}></Route>
          <Route path="reports/daily-sales" element={<DailySalesReport />}></Route>
          <Route path="reports/sales-performance" element={<SalesPerformanceReport />}></Route>
          <Route path="reports/area-demand" element={<AreaDemandReport />}></Route>
          <Route path="reports/top-models" element={<TopModelsReport />}></Route>
          <Route path="reports/delivery-sla" element={<DeliverySlaReport />}></Route>
          <Route path="reports/activity" element={<ActivityReport />}></Route>
          <Route path="user-profile"  element={<UserProfile Module={"Profile"} />}></Route>
          <Route path="reset-password"  element={<ResetPassword Module={"Reset Password"} />}></Route>
          <Route path="lead"  element={<LeadMain Module={"Lead"} />}></Route>
          <Route path="client-communication"  element={<ClientCommunication Module={"Client Communication"} />}></Route>
          <Route path="client-environments"  element={<ClientEnvironmentMain Module={"Client Environments"} />}></Route>
          <Route path="titles"  element={<TitleMain Module={"Titles"} />}></Route>
          <Route path="enquiry"  element={<EnquiryMain Module={"Enquiry Register"} />}></Route>
          <Route path="sales-register"  element={<SalesRegisterMain Module={"Sales Register"} />}></Route>
          <Route path="purchase-register"  element={<PurchaseRegisterMain Module={"Purchase Register"} />}></Route>          
          <Route path="expense-register"  element={<ExpenseRegisterMain Module={"Expense Register"} />}></Route>
          <Route path="finance-register"  element={<FinanceRegisterMain Module={"Finance Register"} />}></Route>
          <Route path="rto"  element={<RTOMain Module={"RTO Register"} />}></Route>
          <Route path="customer"  element={<CustomerMain Module={"Customer"} />}></Route>
          <Route path="color"  element={<ColorMain Module={"Color"} />}></Route>
          <Route path="master-data"  element={<MasterDataMain Module={"Manage List"} />}></Route>
          <Route path="vehicle-entry"  element={<VehicleMain Module={"Vehicle"} />}></Route>
          <Route path="dealer"  element={<DealerMain Module={"Dealer"} />}></Route>
          <Route path="finance-partner"  element={<FinancePartnerMain Module={"Finance Partners"} />}></Route>
          <Route path="handover-items"  element={<HandoverItemsMain Module={"Handover Items"} />}></Route>
          <Route path="handover-register"  element={<HandoverRegisterMain Module={"Handover Register"} />}></Route>
          <Route path="loan-application-form" element={<LoanApplicatgionFromMain Module={"Loan Application Form"} />}></Route>
          <Route path="calendar" element={<CalendarMain Module={"Calendar"} />}></Route>
          <Route path="todo-list" element={<TodoListMain Module={"Todo List"} />}></Route>
          <Route path="payment-followup" element={<PaymentFollowupMain Module={"Payment Followup"} />}></Route>
          <Route path="gallery" element={<GallaryMain Module={"My Gallery"} />}></Route>
          <Route path="ec-product" element={<ProductMain Module={"Product"} />}></Route>
          <Route path="ec-product-category" element={<ProductCategoryMain Module={"Product Category"} />}></Route>
          <Route path="ec-product-sub-category" element={<ProductSubCategoryMain Module={"Product Sub Category"} />}></Route>
          <Route path="ec-homepage-banner" element={<HomepageBannerMain Module={"Homepage Banners"} />}></Route>
          <Route path="ec-vendor" element={<VendorMain Module={"Vendor"} />}></Route>
          <Route path="ec-product-detail-tab-type" element={<ProductDetailTabTypeMain Module={"Product Detail Tab Types"} />}></Route>
          <Route path="ec-promo-banner" element={<PromoBannerMain Module={"Promo Banners"} />}></Route>
          <Route path="order-food" element={<OrderFoodPage />}></Route>
        </Route>
        <Route path="/registeruser" element={<RegisterUser />}></Route>
      </Routes>
    </>
  );
}

export default App;
